import React, { Fragment } from "react"
import Img from 'gatsby-image'
import { Form } from './index'

const Contact = ({ data, forms }) => {
    const { contactInfo, image } = data

    return (
        <Fragment>
            <section className="contact-main">
                <div className="col left">
                    {contactInfo ? contactInfo.map((contact, index) => {
                        return (
                            <div key={index} className="contact">
                            {contact.title && (
                                <h4>{contact.title}</h4>
                            )}
                            {contact.name && (
                                <span className="name">{contact.name}</span>
                            )}
                            {contact.contactMethod.map((c, i) => {
                                return (
                                    <span key={`method-${i}`}>{c.method}</span>
                                )
                            })}
                            {contact.finePrint && (
                                <div className="fine-print" dangerouslySetInnerHTML={{ __html: contact.finePrint }}></div>
                            )}
                            </div>
                        )
                    }) : null}
                </div>
                <div className="col right">
                    <Form forms={forms} />
                    <div className="image-wrapper">
                        {image && (
                            <Img fluid={image?.localFile?.childImageSharp?.fluid} />
                        )}
                    </div>
                </div>
            </section>
        </Fragment>
    )
}

export default Contact
